var map = {
	"./action-sprite/svg/symbols.svg": 182,
	"./custom-sprite/svg/symbols.svg": 181,
	"./doctype-sprite/svg/symbols.svg": 183,
	"./social-round-sprite/svg/symbols.svg": 126,
	"./social-sprite/svg/symbols.svg": 125,
	"./standard-sprite/svg/symbols.svg": 180,
	"./utility-sprite/svg/symbols.svg": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 681;